/* eslint-disable no-promise-executor-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
// import moment from 'moment'
import 'moment-timezone'
import {
  Form,
  //   InputGroup,
  //   Image,
  Button,
  Modal,
  Container,
  // Row,
  ListGroupItem,
  Col,
  InputGroup,
  Row,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faCirclePlus,
  faPenToSquare,
  faSearch,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons'
// import {
//   AuthContext,
//   ToastContext,
// DraftContext,
// } from '../components/ContextProvider'
import apiServices from '../services/apiServices'
// import { LoadingButton, ContainerAndTag } from '../components'
// import { narwhal } from '../asset'

function DeleteModal({ setting }) {
  const { show, name, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header closeButton />
      <Modal.Body className="p-4">
        <div className="d-flex">
          <FontAwesomeIcon
            className="px-0 m-auto text-chelonia text-center"
            style={{
              height: '100px',
            }}
            icon={faCircleExclamation}
          />
        </div>
        <h5 className="text-center lh-lg text-chelonia">
          <br />
          警告！刪除後無法復原！
          <br />
          仍要刪除
          <span className="text-danger">{`「${name}」`}</span>
          嗎？
        </h5>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto me-2"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="narwhal"
          onClick={() => handleClose(true)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function ProjectModal({ setting }) {
  const {
    show,
    form,
    defaultValue = {},
    setDuration,
    handleClose,
    data,
    onDataChange,
  } = setting
  const [showDate, setshowDate] = useState(false)

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header closeButton>
        {defaultValue.setting ? `編輯人員` : `新建人員`}
      </Modal.Header>
      <Modal.Body className="p-4">
        {form.map((f, i) => {
          switch (f.type) {
            case 'date':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      name={f.name}
                      type="text"
                      value={data[f.name] || f.placeholder}
                      placeholder={f.placeholder}
                      onFocus={() => setshowDate(!showDate)}
                      readOnly
                    />
                    <Button
                      variant="chelonia2"
                      onClick={() => setshowDate(!showDate)}
                    >
                      確認
                    </Button>
                  </InputGroup>
                </React.Fragment>
              )
            case 'select':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Select
                    name={f.name}
                    type={f.type}
                    value={data[f.name] || ''}
                    onChange={onDataChange}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  >
                    <option value="">未選擇</option>
                    {f.content.map(({ label, value }) => (
                      <option value={value}>{label}</option>
                    ))}
                  </Form.Select>
                </React.Fragment>
              )
            case 'file':
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Control
                    name={f.name}
                    type={f.type}
                    onChange={async (e) => {
                      // const formData = new FormData()
                      // formData.append('file', e.target.files[0])
                      onDataChange({
                        target: {
                          name: f.name,
                          value: e.target.files[0],
                        },
                      })
                      console.log('file append')
                      const temp = URL.createObjectURL(e.target.files[0])
                      const audio = document.createElement('audio')
                      audio.muted = true
                      console.log('audio created')
                      const source = document.createElement('source')
                      source.src = temp // --> blob URL
                      audio.preload = 'metadata'
                      audio.appendChild(source)
                      console.log('reading metadata')
                      audio.onloadedmetadata = () => {
                        console.log(audio.duration)
                        setDuration(audio.duration)
                      }
                      // const uploaded = await apiServices.data({
                      //   path: `material/file`,
                      //   method: 'post',
                      //   data: formData,
                      //   contentType: 'multipart/form-data',
                      // })
                      // console.log(uploaded)
                    }}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  />
                </React.Fragment>
              )
            default:
              return (
                <React.Fragment key={i}>
                  <Form.Label className="mb-1 mt-3 fw-bold text-chelonia">
                    {f.label}
                  </Form.Label>

                  <Form.Control
                    name={f.name}
                    type={f.type}
                    value={data[f.name] || ''}
                    onChange={onDataChange}
                    placeholder={f.placeholder}
                    onFocus={() => setshowDate(false)}
                  />
                </React.Fragment>
              )
          }
        })}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="narwhal"
          onClick={() => handleClose(true)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-wom">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除
                {/* {show && target
                  ? target.setting.name ||
                    `專案${target.setting.id || target.project_id}`
                  : '專案'} */}
                嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="wom" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Users() {
  //   const { auth, setAuth } = useContext(AuthContext)
  //   const { setToast } = useContext(ToastContext)
  //   const navigate = useNavigate()

  const [users, setusers] = useState([])
  const getUsers = async () => {
    const res = await apiServices.data({
      path: 'user/',
      method: 'get',
    })
    setusers(res)
  }
  useEffect(() => {
    getUsers()
  }, [])

  const form = [
    {
      name: 'name',
      label: '名稱',
      placeholder: '輸入名稱',
      type: 'text',
    },
    {
      name: 'email',
      label: '信箱',
      placeholder: '輸入信箱',
      type: 'text',
    },
    {
      name: 'password',
      label: '密碼',
      placeholder: '輸入密碼',
      type: 'password',
    },
    {
      name: 'admin',
      label: '權限',
      placeholder: '選擇權限',
      type: 'select',
      content: [
        { label: '管理員', value: true },
        { label: '使用者', value: false },
      ],
    },
    {
      name: 'lookerstudio',
      label: '成效連結',
      placeholder: '輸入連結',
      type: 'text',
    },
  ]
  const [data, setdata] = useState({})
  const [showEdit, setshowEdit] = useState(false)

  const onDataChange = (e) =>
    setdata({ ...data, [e.target.name]: e.target.value })

  const [selectedId, setselectedId] = useState('')
  const [deleteShow, setdeleteShow] = useState(false)
  const handleDeleteClose = async (value) => {
    if (value) {
      await apiServices.data({
        path: `user/${selectedId}`,
        method: 'delete',
      })
    }
    setdeleteShow(false)
    setselectedId('')
    getUsers()
  }
  const handleEditClose = async (value) => {
    if (value) {
      await apiServices.data({
        path: selectedId ? `user/${selectedId}` : `user/`,
        method: selectedId ? 'put' : 'post',
        data,
      })
    }
    setshowEdit(false)
    setselectedId('')
    getUsers()
  }

  useEffect(() => {
    const target = users.find(({ user_id }) => user_id === selectedId)
    if (showEdit) {
      setdata(
        form.reduce(
          (prev, cur) => ({
            ...prev,
            [cur.name]: target
              ? target[cur.name] || target.setting[cur.name]
              : '',
          }),
          {}
        )
      )
    }
  }, [showEdit, selectedId])

  const [tempSearch, setTempSearch] = useState('')
  const [search, setSearch] = useState('')
  const [focus, setFocus] = useState(false)

  return (
    <Container
      className="bg-dots-light h-100 w-100 d-flex flex-column position-relative"
      style={{ overflowY: 'auto', overflowX: 'hidden' }}
      // onClick={() => setEditing('')}
    >
      <Row className="px-5">
        <Col xs={2} className="d-flex">
          <h5 className="my-auto text-chelonia-light fw-bold">人員管理</h5>
        </Col>
        <Col xs={2} />
        <Col xs={3} className="d-flex justifu-content-end" />
        <Col xs={5} className="d-flex pe-0">
          <InputGroup>
            <Form.Control
              placeholder="輸入關鍵字以搜尋人員..."
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              value={tempSearch}
              onChange={(event) => setTempSearch(event.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              onKeyDown={(event) => {
                if (
                  event.key === 'Enter' &&
                  !event.nativeEvent.isComposing &&
                  focus
                )
                  setSearch(tempSearch)
              }}
            />
            <Button
              variant="outline-dark"
              id="button-addon2"
              title="搜 尋"
              onClick={() => setSearch(tempSearch)}
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
          <Button
            className="ms-4 w-50"
            variant="narwhal"
            onClick={() => {
              // setselectedId('')
              setshowEdit(true)
            }}
          >
            新增人員&ensp;
            <FontAwesomeIcon icon={faCirclePlus} />
          </Button>
        </Col>
      </Row>
      <Row className="px-5 pt-3">
        {users
          .filter(({ name, email }) =>
            `${name}${email}`.toLowerCase().includes(search.toLowerCase())
          )
          .map(({ name, user_id, email, setting }) => (
            <ListGroupItem
              action
              className="d-flex border p-3 rounded"
              key={user_id}
            >
              <Col
                xs={3}
                className="my-auto text-start oneLineEllipsis fs-7"
                title={name}
              >
                {name}
              </Col>
              <Col
                xs={4}
                className="my-auto text-start oneLineEllipsis fs-7"
                title={email}
              >
                {email}
              </Col>
              <Col xs={2} className="my-auto text-start oneLineEllipsis fs-7">
                角色｜{setting.admin ? '管理員' : '使用者'}
              </Col>
              <Col xs={3} className="d-flex my-auto">
                <Button
                  className="ms-auto"
                  style={{ boxShadow: 'none' }}
                  variant="edit"
                  onClick={(e) => {
                    setselectedId(user_id)
                    setshowEdit(true)
                    e.stopPropagation()
                  }}
                  title="指派"
                  size
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                </Button>
                <Button
                  style={{ boxShadow: 'none' }}
                  variant="red"
                  onClick={(e) => {
                    setselectedId(user_id)
                    setdeleteShow(true)
                    e.stopPropagation()
                  }}
                  title="刪 除"
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </Button>
              </Col>
            </ListGroupItem>
          ))}
      </Row>
      <ProjectModal
        setting={{
          show: showEdit,
          form,
          data,
          onDataChange,
          defaultValue: {},
          handleClose: handleEditClose,
        }}
      />
      <DeleteModal
        setting={{
          show: deleteShow,
          name: users.find(({ user_id }) => user_id === selectedId)?.name,
          handleClose: handleDeleteClose,
        }}
      />
    </Container>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ProjectModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

DeleteModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Users
